import _ from 'lodash'
import termOnePath from '../../lib/termOnePath'

export default ({ formikProps: { values }, formikProps }) =>
  _.get(values, `${termOnePath({ formikProps })}.type`)
